import Ajax from "Utils/ajax";
export const leaveStatement = (data) => Ajax.post('hr/leaveStatement',data);
export const getAllStaff = (data) => Ajax.post('hr/getAllStaff',data);
export const getAllActiveDeactiveStaff = (data) => Ajax.post('hr/getAllActiveDeactiveStaff',data);